(function () {
  var STORAGE_KEY = 'ccs_pricing_notice_dismissed_at';

  function parseConfig(root) {
    if (!root) return null;
    var hours = parseInt(root.dataset.dismissHours, 10);
    if (Number.isNaN(hours) || hours < 1) hours = 24;
    var delay = parseInt(root.dataset.showDelay, 10);
    if (Number.isNaN(delay) || delay < 0) delay = 0;
    return {
      hours: hours,
      delay: delay,
      designMode: root.dataset.designMode === 'true',
    };
  }

  function isDismissed(hours) {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return false;
      var dismissedAt = parseInt(raw, 10);
      if (Number.isNaN(dismissedAt)) return false;
      return Date.now() - dismissedAt < hours * 60 * 60 * 1000;
    } catch (e) {
      return false;
    }
  }

  function markDismissed() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {
      /* ignore private browsing */
    }
  }

  function openNotice(root) {
    root.hidden = false;
    document.documentElement.classList.add('ccs-pricing-notice-open');
    var panel = root.querySelector('.ccs-pricing-notice__panel');
    var accept = root.querySelector('[data-pricing-notice-accept]');
    if (accept) accept.focus();
    if (panel) panel.setAttribute('tabindex', '-1');
  }

  function closeNotice(root, persist) {
    root.hidden = true;
    document.documentElement.classList.remove('ccs-pricing-notice-open');
    if (persist) markDismissed();
  }

  function init() {
    var root = document.getElementById('ccs-pricing-notice');
    var config = parseConfig(root);
    if (!root || !config) return;

    if (!config.designMode && isDismissed(config.hours)) return;

    var accept = root.querySelector('[data-pricing-notice-accept]');
    if (accept) {
      accept.addEventListener('click', function () {
        closeNotice(root, !config.designMode);
      });
    }

    root.addEventListener('click', function (event) {
      if (event.target === root.querySelector('.ccs-pricing-notice__backdrop')) {
        /* require explicit accept — backdrop does not dismiss */
      }
    });

    window.setTimeout(function () {
      openNotice(root);
    }, config.delay * 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
